import Cookies from "js-cookie";

const availableLanguages = ["pt"] as const;
export type AvailableLanguages = typeof availableLanguages[number];

class TranslationServiceClass {

    private readonly cookieName: string = "language";

    GetAvailableLanguages(): ReadonlyArray<string> {
        return availableLanguages;
    }

    GetValueFromCookie(): string | undefined {
        var languageInCookie = Cookies.get(this.cookieName);
        return languageInCookie;
    }

    GetLanguage(): AvailableLanguages {
        //Vamos tentar ver na cookie a language da pessoa
        var languageInCookie = this.GetValueFromCookie();

        var languageToReturn: AvailableLanguages = "pt";

        //Se a cookie não existe ou o idioma é vazio, ou idioma não existe na listagem definida
        if (typeof languageInCookie == "undefined" || languageInCookie == null || this.GetAvailableLanguages().includes(languageInCookie.toLowerCase() as AvailableLanguages) === false) {

            languageToReturn = this.GetBrowserLanguage();
        } else {
            languageToReturn = languageInCookie?.toLowerCase() as AvailableLanguages;
        }

        this.SetLanguage(languageToReturn);
        return languageToReturn;
    }

    GetBrowserLanguage(): AvailableLanguages {

        //Ficamos com a primeira parte do idioma do browser, exemplo 'pt-PT', ficamos com "pt"
        var browserLanguage: string = navigator.language.split("-")[0];

        //Verificamos se o idioma do browser está na lista de idiomas permitidos
        if (availableLanguages.includes(browserLanguage.toLowerCase() as AvailableLanguages) === true) {
            return browserLanguage as AvailableLanguages;
        }

        return "pt";
    }

    SetLanguage(language: AvailableLanguages) {
        Cookies.set(this.cookieName, language);
    }
}

export const TranslationService = new TranslationServiceClass();
